<div class="power-bi-report-container">
    <powerbi-report [embedConfig]="getPowerBIEmbedConfig(configDto)" [cssClassName]="reportClass"
        [phasedEmbedding]="false" [eventHandlers]="eventHandlersMap" *ngIf="configDto$ | async as configDto">
    </powerbi-report>


    <div class="loading" *ngIf="!isPowerBIEmbedRendered()">
        <img src="../../../assets/REIDIN-Loading.gif" height="75" />
    </div>
</div>